







































import { Component, Prop, Vue } from "vue-property-decorator";
import { getFinishImage } from "@/utility/helpers";
import {
  Finish,
  FinishDisplayName,
  FinishHandle
} from "@/models/products/finish";
@Component
export default class DropdownFinishes extends Vue {
  @Prop() finishes!: Finish[];
  @Prop() selected!: FinishHandle;
  protected FinishDisplayName = FinishDisplayName;
  protected getFinishImage = getFinishImage;

  public updateFinish(fieldValue: string) {
    this.$emit("updateItem", fieldValue);
  }

  get displayName(): string {
    if (this.selected) {
      const name = (this.selected as any).toUpperCase();
      return FinishDisplayName[name];
    } else {
      return "";
    }
  }
}
